<template>
  <div class="MemberProfile">   
    <div>
      <v-layout row v-if="errors">
            <v-flex>
              <Alert @dismissed="onDismissed" :text="errors"></Alert>
            </v-flex>
          </v-layout>
    <ProfileHeader :user="member" :loading="loading" @profileImageSelected="handleProfileImageSelected"/>
    <v-row>
        <v-col sm="12" md="6">
            <ProfileDetails :ProfileDetails="employer" @update-employer="handleUpdateEmployer" @edit="editMemberTrigger($event)"/>
        </v-col>
        <v-col sm="12" md="6">
          <v-col class="mt-0 pt-0">
            <RolesCard :roles="roles"></RolesCard>
          </v-col>
          <v-col>
            <Privacy  @change-password-clicked="changePassword"></Privacy>
          </v-col>
        </v-col>
    </v-row>
    <PasswordReset
      :popup="passwordChange"
       @modalStatus="changePasswordModalStatus($event)"
       @successReset="successReset"
       />
       <div class="googleAuth"><GoogleAuthRegister/></div>
    </div>
      <Snackbars :text="succesMsg" :snackbar="snackbar" :color="'success'" @classSnackbar="clossSnackbar"/>
  </div>
</template>
  
  <script>
  import { createNamespacedHelpers } from "vuex";
  const { mapGetters } = createNamespacedHelpers("auth");

  import PasswordReset from "@/components/profile/PasswordReset";
  import GoogleAuthRegister from "@/components/profile/GoogleAuthRegister";
  import Snackbars from "@/components/shared/Snackbars";
  import ProfileHeader from "@/components/profile/ProfileHeader";
  import ProfileDetails  from "@/components/profile/ProfileDetails";
  import RolesCard from "@/components/profile/RolesCard";
  import Privacy from "@/components/profile/Privacy";
  import { AuthService } from "@/services/auth-service.js";
  import { EmployerService } from "@/services/employer-service.js";
  import { checkError } from "@/config/errors.js";
  import Alert from "@/components/shared/Alert";
  
  export default {
    name: "MemberProfile",
    components: {
      Snackbars,
      PasswordReset,
      ProfileHeader,
      ProfileDetails,
      GoogleAuthRegister,
      RolesCard,
      Privacy,
      Alert
    },
    data: () => ({
      title: "Member Info",
      editMemberModal: false,
      snackbar: false,
      confirmOpen: false,
      succesMsg: "",
      selectedId: null,
      memberId: localStorage.getItem("user_id"),
      passwordChange:false,
      roles:[],
      employer: null,
      errors: null,
      loading: false,
    }),
    mounted() {   
      this.$store.dispatch("auth/getProfile");
      this.getUserRoles();
      this. getEmployerInfo();
    },
    computed: {
      ...mapGetters({     
        member: "profile"
      })
    },

    methods: {
      getEmployerInfo() {
      this.loading = true;
      EmployerService.getEmployerInfo()
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.employer = response.data.data;
          }
        })
        .catch(error => {
          this.loading = false;
          let data = error.response.data;
          this.errors =  data ;
        });
      },
      editMemberTrigger(value) {
        if (this.member != null) {
          this.editMemberModal = value;
        }
      },
  
      changeModalStatus(value) {
        this.memberModal = value;
      },
      clossSnackbar() {
        this.snackbar = false;
      },
      changeEditModalStatus(value) {    
        this.editMemberModal = value;      
      },
  
      setEditData(value) {
        this.editMemberModal = true;
        this.selectedId = value;
      },
      successEdit() {
        this.selectedId = null;
        this.$store.dispatch("auth/getProfile");
        this.succesMsg = "Profile successfully updated";
        this.snackbar = true;
        this.editMemberModal = false;
      },
      changePassword(){
        this.passwordChange = true;
      },
      changePasswordModalStatus(){
        this.passwordChange = ! this.passwordChange;
      },
       successReset() { 
        this.succesMsg = "Password successfully updated";
        this.snackbar = true;
        this.passwordChange = false;
      },
      getUserRoles() {
      this.loading = true;
      AuthService.getUserRoles()
        .then(response => {
          this.loading = false;
          if (response.data) {
           this.roles = response.data.data;
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          this.errors =  data ;
      });
    },
    handleProfileImageSelected(file) {
      const formData = new FormData();
      formData.append('profile_image', file);
      EmployerService.uploadEmployerProfilePic(formData)
      .then((response) => {
          this.loading = false;
          if (response.data) {
            this.succesMsg = response.data.message;
            this.snackbar = true;       
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          console.log(data)
          window.scrollTo(0, 0);

        });
    },
    handleUpdateEmployer(data){
      this.errors = null;
      this.loading = true;
      EmployerService.updateEmployer(data)
      .then((response) => {
        this.loading = false;
          if (response.data) {
            this.succesMsg = response.data.message;
            this.snackbar = true;         
          }
          this.getEmployerInfo();
        })
        .catch((error) => {
          
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
      });
    }
    }
  };
  </script>

  <style>
  .googleAuth {
    margin-top: 2%;
  }
</style>
  